// extracted by mini-css-extract-plugin
export default {"licenseImg":"CuracauLicense_licenseImg__Qpt9t","link":"CuracauLicense_link__MTVUK"};